import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  List,
  ListItem,
  ListItemText,
  Collapse,
  Divider

} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';


import withAlert from "../../../../hoc/withAlert";
import Eating from '../Eating'
import {
  getEatingSelector,
  getEatingByNameSelector
} from '../../../../store/eating';



const useStyles = makeStyles(theme => ({
  nestedHead: {
    paddingLeft: theme.spacing(4),
  },
  nested: {
    paddingLeft: theme.spacing(6),
  },
  weekend: {
    backgroundColor: '#e0f2f1'
  }
}));

const Day = props => {
  const { day, meetingId, onCheckedOne,setSnackMessage, setSnackType, setOpenSnack } = props;


  // console.log('orderContext', orderContext.actionType, orderContext.ticketId);
  const { date, isWeekend } = day
  const classes = useStyles();

  const eating = useSelector(getEatingSelector);
  // console.log('eating',eating);
  
  // Состояние открыт закырт
  const [open, setOpen] = useState(false);

  const [dishes, setDishes] = useState([])
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState({});



  //  Обработчик свертывания развертывания
  const handleClick = () => {
    setOpen(!open);
  };


  const handleSelectChange = selectedOption => {
    setSelectedValue(selectedOption);
    // console.log('selectedOption',selectedOption);
  };

  const handleAdd = async () => {
    // await dispatch(addMealCombo({mealId:selectedValue.value, comboId:rowData.id}))
  }

  const handleDelete = async (mealComboId) => {
    // await dispatch(deleteMealCombo({mealComboId, comboId:rowData.id}))
  }


  return (

    <React.Fragment>

      <ListItem button onClick={handleClick}
       className={`${classes.nestedHead} ${isWeekend ? classes.weekend : ''}`}
       >
        {open ? <ExpandLess /> : <ExpandMore />}
        <ListItemText primary={date} />
      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit className={classes.nested}>
        <Eating name={'Завтрак'} date={date} meetingId={meetingId} eating={useSelector(getEatingByNameSelector('Завтрак'))}/>
        <Divider style={{marginBottom:20}}/>
        <Eating name={'Обед'} date={date} meetingId={meetingId} eating={useSelector(getEatingByNameSelector('Обед'))}/>
        <Divider style={{marginBottom:20}}/>
        <Eating name={'Ужин'} date={date} meetingId={meetingId} eating={useSelector(getEatingByNameSelector('Ужин'))}/>
        {/* <Divider style={{marginBottom:20}}/> */}
        {/* <Eating name={'Бар'} date={date} meetingId={meetingId} eating={useSelector(getEatingByNameSelector('Бар'))}/> */}
      </Collapse>
    </React.Fragment>


  );
};


export default withAlert(Day);
